import React from 'react';

import { usePopoverContext } from '@lyearn/ui';

import ActionButton from './ActionButton';
import { MenuActionButtonProps } from './types';

const MenuActionButton = React.forwardRef(
  (
    {
      tag,
      onDelete,
      onClick,
      className,
      selectedTagValue,
      defaultPlaceholder,
      error,
      count,
      readOnly,
    }: MenuActionButtonProps,
    ref?: React.Ref<HTMLButtonElement> | undefined,
  ) => {
    const { open: isOpen } = usePopoverContext();

    return (
      <ActionButton
        ref={ref}
        className={className}
        count={count}
        defaultPlaceholder={defaultPlaceholder}
        error={error}
        isInFocus={isOpen}
        readOnly={readOnly}
        selectedTagValue={selectedTagValue}
        tag={tag}
        onClick={onClick}
        onDelete={onDelete}
      />
    );
  },
);

export default React.memo(MenuActionButton);
